import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SpActionButton } from '../../../models/client-models/entities/sp-columns';

@Component({
  selector: 'app-actions-cell-renderer',
  templateUrl: './actions-cell-renderer.html',
  styleUrls: ['./actions-cell-renderer.scss'],
  standalone: false,
})
export class ActionsCellRendererComponent implements ICellRendererAngularComp {
  @Input() actions: SpActionButton[] = [];

  params: any;
  row: any;

  agInit(params: any): void {
    this.actions = params.actions;
    this.row = params.data;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  onActionClick(action: SpActionButton) {
    action.onClick(this.row);
  }
}
